<template>
  <div>
    <iframe id="okrIframe" name="okrIframe" src="about:blank"
      :style="dBHeight" style="width: 100%; border: 0px; margin: 0px;" scrolling="auto"></iframe>
    <form ref="OKR_SLO_IF" target="okrIframe">
      <input type="hidden" id="okrId" name="okrId" />
      <input type="hidden" id="companyId" name="companyId" value="202" />
      <input type="hidden" id="deptId" name="deptId" value="" />
      <input type="hidden" id="currentUnitId" name="currentUnitId" />
      <input type="hidden" id="selectedQrtCd" name="selectedQrtCd" />
      <input type="hidden" id="okrRegYn" value="Y" />
      <input type="hidden" id="checkIsExternal" name="checkIsExternal" value="false" />
      <input type="hidden" id="destination" name="destination" value="/neo/services/okr/okr/myOkrGet.mvc" />
      <input type="hidden" id="listName" name="listName" />
      <input type="hidden" id="usageMenuId" name="usageMenuId" />
      <input type="hidden" id="authType" name="authType" />
      <input type="hidden" id="menuName" name="menuName" />
      <input type="hidden" id="fileName" name="fileName" /> 
      <input type="hidden" id="hqDeptSelectUnitId" name="hqDeptSelectUnitId" />     
    </form>
    <modals-container/>
  </div>  
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      dBHeight: {
        'min-height': (window.innerHeight - 54) + 'px'
      },
      type :  null
    };
  },
  created() {
    window.addEventListener("resize", this.resizeOkrIframe);
  },
  mounted() {
    this.type = this.$route.params.type
    if(this.type === undefined){
      this.getMyInfo();
    }else{
      if(this.getCookie("4579334b5628eb3295a007782bedvb86fb2365ca5c8fdw1ww!caf9a02d0c56") !=null){
        this.callOkrMain();
      }else{
        this.setLoginCookie();
      }
    }    
  },
  methods: {
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
      resizeOkrIframe() {
        this.dBHeight = {
          'min-height': (window.innerHeight - 54) + 'px'
        }
      },
      setLoginCookie(){
      let obj = this;
      let reqData = {
        url : "/api/auth/setLoginCookie",
        method : "post"
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res != null){
          if (res.errorCode != null) {
            console.log(res.errorCode);
          }else{
            obj.callOkrMain();
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
      callOkrMain(){
        let obj = this; 
        console.log("obj.type : "+obj.type);
        obj.$refs.OKR_SLO_IF.method = 'POST';
        obj.$refs.OKR_SLO_IF.action = '/neo/branch/common/slo/loginOKR.mvc?destination='+obj.type;
        obj.$refs.OKR_SLO_IF.companyId.value = null;
        obj.$refs.OKR_SLO_IF.checkIsExternal.value = null;
        obj.$refs.OKR_SLO_IF.destination.value = null;
        console.log(obj.$refs.OKR_SLO_IF.action);
        obj.$refs.OKR_SLO_IF.submit();
      },
      getMyInfo() {
        let obj = this;
        let reqData = {
          url: "/api/auth/org/getUserInfo",
          method: "post",
        };
        obj.showLoadingbar();
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function(res) {
            obj.hideLoadingbar();
            if(res.result !== null) {
              if(res.result.errorCode === undefined) {
                if(obj.$route.params.destination !== null) {
                  if (obj.$route.params.destination == undefined){
                    obj.$refs.OKR_SLO_IF.destination.value = '/neo/services/okr/main.mvc?page=/neo/services/okr/home/ohT1M01.mvc';
                  } else {
                    obj.$refs.OKR_SLO_IF.destination.value = obj.$route.params.destination;
                  }

                  // 2021.03.15 tenantId 추가
                  let tenantId = localStorage.getItem("tenantId");
                  let tempUrl = obj.$refs.OKR_SLO_IF.destination.value;
                  if (tenantId == "203" && (tempUrl.indexOf("/okr/home/ohT") > -1 || tempUrl.indexOf("/okr/list") > -1)) {
                    obj.$refs.OKR_SLO_IF.destination.value = 'okrRegLink';
                  }
                  obj.$refs.OKR_SLO_IF.deptId.value = res.result.orgDeptUserView.deptId;
                  obj.$refs.OKR_SLO_IF.method = 'POST';
                  obj.$refs.OKR_SLO_IF.action = '/neo/branch/common/slo/loginOKR.mvc';
                  obj.$refs.OKR_SLO_IF.authType.value = obj.$route.params.authType;
                  obj.$refs.OKR_SLO_IF.listName.value = obj.$route.params.listName;
                  obj.$refs.OKR_SLO_IF.fileName.value = obj.$route.params.fileName;
                  obj.$refs.OKR_SLO_IF.menuName.value = obj.$route.params.menuName;
                  obj.$refs.OKR_SLO_IF.usageMenuId.value = obj.$route.params.usageMenuId;
                  // obj.$refs.OKR_SLO_IF.usageMenuId.value = obj.$route.params.getSubMenuStatus;
                  obj.$refs.OKR_SLO_IF.selectedQrtCd.value = obj.$route.params.selectedQrtCd;
                  obj.$refs.OKR_SLO_IF.currentUnitId.value = obj.$route.params.currentUnitId;
                  obj.$refs.OKR_SLO_IF.hqDeptSelectUnitId.value = obj.$route.params.hqDeptSelectUnitId;
                  
                  if (tenantId) {
                    obj.$refs.OKR_SLO_IF.companyId.value = tenantId;
                  }
                  obj.$refs.OKR_SLO_IF.submit();
                }
              }
            }
        })
        .catch(function(err) {
          console.log(err);
        });
      },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/okr/OkrMain.vue